import * as React from 'react'
import { DataGrid } from '@mui/x-data-grid'
import {
  Box,
  Button,
  Chip,
  IconButton,
  Link,
  MenuItem,
  Paper,
  Select,
  Skeleton,
  Typography,
} from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import { BackArrowIcon, GoToLiveIcon, } from '../../icons'
import { GlobalStyles } from '@mui/material'
import UniversitySummary from '../university-table/UniversitySummary'
import UserCommentModal from './CommentModal/UserCommentModal'
import UserReviewCoursesListingManagementRows from './CourseData/userdata'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { fetchCourseList, fetchCourseNameList } from '../../api/courseApi'
import { fetchLatestReviewComment } from '../../api/commentApi'
import { handlePreview } from '../CourseDetails/CourseDetailsForm'
import CommonTableFormat from '../common/CommonTableFormat'
import CommonFilterTab from '../common/CommonFilterTab'
import { setPaginationFiled } from '../../containers/pagination-container/reducer/paginationSlice'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { defaultPaginationValues, filterTypeOptions, studentStatusList } from '../../utils/constant'
import { setFilterField } from '../../containers/filter-container/reducer/filterSlice'
import { formatMultiQueryParams, jsonParserFormatter } from '../../utils/helperFunction'
import CommonDataTable from '../common/CommonDataTable'
import { fetchUniversitiesNames } from '../../api/universityApi'

const CourseReviewUser = () => {
  const authSlice = useSelector(state=>state.auth)
  const filterSlice = useSelector(state=>state.filter?.filters)
  const LOCATION_FILTER = `filters:${window.location.pathname}`
  const dispatch = useDispatch()
  const location = useLocation()
  const [rows, setRows] = React.useState([])
  const [loading, setLoading] = React.useState(true)
  const navigate = useNavigate()
  const [openCommentModal, setOpenCommentModal] = React.useState(false)
  const [selectedRowId, setSelectedRowId] = React.useState(null)
  const [commentText, setCommentText] = React.useState('')
  const [rowCount, setRowCount] = React.useState(0);
  const [searchFilter,setSearchFilter] = React.useState({})
  const [pageFilters, setPageFilters] =  React.useState(defaultPaginationValues);
  const [isRender,setIsRender] = React.useState(false)  
  const [universitySuggestion,setUniversitySuggesion] = React.useState([])
  const [courseSuggestion,setCourseSuggestion] = React.useState([])

    const handleFliterSliceChange = (values = {}, isReset = false) => {
      let isQuery = typeof values === "object" && Object.keys(values)?.length
      isQuery && dispatch(setFilterField({ pathname: LOCATION_FILTER, filters: JSON.stringify({ ...(isReset ? {} : pageFilters), ...defaultPaginationValues, ...values }) }))
    }

  const handleOpenCommentModal = async (rowId, type = 'course') => {
    setSelectedRowId(rowId);
    setCommentText('');
    setOpenCommentModal(true);

    try {
      const latestComment = await fetchLatestReviewComment(type, rowId);
      setCommentText(latestComment || '');
    } catch (err) {
      setCommentText('');
    }
  };

  const handleSaveComment = () => {
    setRows((prev) =>
      prev.map((row) =>
        row.id === selectedRowId ? { ...row, comments: commentText } : row
      )
    )
    setOpenCommentModal(false)
  }

  React.useEffect(() => {
    setLoading(true)
    const multiFilter = formatMultiQueryParams(filterSlice[LOCATION_FILTER])
    fetchCourseList(setRows,{...searchFilter, ...multiFilter, isMultiFilter: true },true,false,setRowCount)
      .finally(() => setLoading(false))
  }, [filterSlice[LOCATION_FILTER], isRender])

    // handle extra filter tabs changes
    React.useEffect(() => {
      if (pageFilters?.page) {
        handleFliterSliceChange({ page: 0 })
      } else {
        setIsRender(!isRender)
      }
    }, [searchFilter])
  
    // parse page filters
    React.useEffect(() => {
      const values = jsonParserFormatter(filterSlice[LOCATION_FILTER])
      setPageFilters(values)
    }, [filterSlice[LOCATION_FILTER]])

  // load course/ universities for filter suggestions
  React.useEffect(() => {
       fetchUniversitiesNames((result)=>setUniversitySuggesion(result?.map(item=>({...item,value:item?.label}))))
            .catch(err=>console.log("error:---",err))
    
        fetchCourseNameList((result) => { setCourseSuggestion(result?.map(el => ({ label: el?.course, value: el?.course }))) }, {skipLimit:true})
          .catch(() => { })
  }, [])

  function getStatusClass(status) {
    switch (status) {
      case 'Approved':
        return 'status-live'
      case 'Draft':
        return 'status-draft'
      case 'Re-Sumbited':
        return 'status-draft'
      case 'Pending':
        return 'status-pending'
      case 'Rework':
        return 'status-deactivated'
      default:
        return ''
    }
  }
  const columns = [
    {
      field: 'sNo',
      headerName: 'S. No.',
      width: 60,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      // renderCell: (params) => {
      //   return rows?.findIndex((r) => r.id === params.row.id) + 1
      // },
    },
    {
      field: 'courseId',
      headerName: 'Course ID',
      flex: 1,
      minWidth: 130,
      cellClassName: 'sticky-col-1',
      headerClassName: 'sticky-col-1',
      filterColumnName:"courseId",
      filterType:filterTypeOptions.string,
    },
    {
      field: 'course',
      headerName: 'Course',
      flex: 2,
      minWidth: 280,
      filterColumnName:"courseName",
      filterType:filterTypeOptions.selection,
      selection:courseSuggestion,
      renderCell: (params) => {
        const { img, course } = params.row

        const getInitials = (fullName) => {
          if (!fullName) return ''
          const words = fullName.trim().split(' ').filter(Boolean)
          if (words.length === 1) return words[0][0]?.toUpperCase() || ''
          if (words.length === 2) return (words[0][0] + words[1][0]).toUpperCase()
          return (words[0][0] + words[1][0] + words[2][0]).toUpperCase()
        }

        const stringToColor = (str) => {
          let hash = 0
          for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash)
          }
          const c = (hash & 0x00ffffff).toString(16).toUpperCase()
          return '#' + '00000'.substring(0, 6 - c.length) + c
        }

        const bgColor = stringToColor(course || 'Course')

        return loading ? (
          <Skeleton width={150} />
        ) : (
          <Box
            display="flex"
            alignItems="center"
            gap={1}
            sx={{ cursor: 'pointer' }}
          >
            {img ? (
              <Box
                component="img"
                src={img}
                alt="universityLogo"
                sx={{
                  width: 40,
                  height: 40,
                  padding: '5px',
                  borderRadius: '50%',
                  objectFit: 'contain',
                  backgroundColor: '#fff',
                  boxShadow: '0 1px 4px rgba(0, 0, 0, 0.15)',
                  display: 'block',
                  maxHeight: 60,
                }}
              />
            ) : (
              <Box
                sx={{
                  minWidth: 35,
                  minHeight: 35,
                  maxWidth: 35,
                  maxHeight: 35,
                  borderRadius: '50%',
                  backgroundColor: bgColor,
                  color: '#fff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 500,
                  fontSize: '10px',
                  textTransform: 'uppercase',
                  boxShadow: '0 1px 4px rgba(0, 0, 0, 0.15)',
                }}
              >
                {getInitials(course)}
              </Box>
            )}
            {params.value}
          </Box>
        )
      },
    },
    {
      field: 'university',
      headerName: 'University',
      flex: 2,
      minWidth: 260,
      filterColumnName:"university",
      filterType:filterTypeOptions.selection,
      selection:universitySuggestion,
      renderCell: (params) => {
        const { universityLogo, university, universityId } = params.row
        const displayName = university

        const getInitials = (fullName) => {
          if (!fullName) return ''
          const words = fullName.trim().split(' ').filter(Boolean)
          if (words.length === 1) return words[0][0]?.toUpperCase() || ''
          if (words.length === 2) return (words[0][0] + words[1][0]).toUpperCase()
          return (words[0][0] + words[1][0] + words[2][0]).toUpperCase()
        }

        const stringToColor = (str) => {
          let hash = 0
          for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash)
          }
          const c = (hash & 0x00ffffff).toString(16).toUpperCase()
          return '#' + '00000'.substring(0, 6 - c.length) + c
        }

        const bgColor = stringToColor(displayName || 'University')

        return loading ? (
          <Skeleton width={150} />
        ) : (
          <Box display="flex" alignItems="center" gap={1} sx={{ height: '100%' }}>
            {universityLogo ? (
              <Box
                component="img"
                src={universityLogo}
                alt="universityLogo"
                sx={{
                  width: 40,
                  height: 40,
                  padding: '5px',
                  borderRadius: '50%',
                  objectFit: 'contain',
                  backgroundColor: '#fff',
                  boxShadow: '0 1px 4px rgba(0, 0, 0, 0.15)',
                  display: 'block',
                  maxHeight: 60,
                }}
              />
            ) : (
              <Box
                sx={{
                  minWidth: 35,
                  minHeight: 35,
                  maxWidth: 35,
                  maxHeight: 35,
                  borderRadius: '50%',
                  backgroundColor: bgColor,
                  color: '#fff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 500,
                  fontSize: '10px',
                  textTransform: 'uppercase',
                  boxShadow: '0 1px 4px rgba(0, 0, 0, 0.15)',
                }}
              >
                {getInitials(displayName)}
              </Box>
            )}
            <Box>
              <Typography sx={{ fontSize: '13px !important', fontWeight: 500 }}>
                {displayName}
              </Typography>
              {params.row.universityNote && (
                <Typography sx={{ fontSize: '11px !important', fontWeight: '500', color: '#363853' }}>
                  ({params.row.universityNote})
                </Typography>
              )}
              <Typography
                sx={{ fontSize: '11px !important', fontWeight: '500', color: '#6E7485', paddingTop: '4px' }}
              >
                University ID: {universityId}
              </Typography>
            </Box>
          </Box>
        )
      },
    },
    {
      field: 'gotoLive',
      headerName: 'Preview',
      minWidth: 100, // fixed icon button
      filterable:false,
      renderCell: (params) =>
        loading ? (
          <Skeleton variant="circular" width={24} height={24} />
        ) : (
          <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', height: '100%' }}>
            <IconButton
              color="primary"
              onClick={() => handlePreview(params?.row?.id, 'course')}
            >
              <GoToLiveIcon />
            </IconButton>
          </Box>
        ),
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      minWidth: 150,
      filterColumnName:"status",
      filterType:filterTypeOptions.selection,
      selection:studentStatusList,
      renderCell: (params) =>
        loading ? (
          <Skeleton width={70} />
        ) : (
          <Chip
            label={params.value}
            size="small"
            icon={
              <FiberManualRecordIcon
                className={getStatusClass(params.value)}
                sx={{
                  fontSize: 10,
                  color: getStatusColor(params.value),
                }}
              />
            }
            sx={{
              bgcolor: getStatusBgColor(params.value),
              color: getStatusTextColor(params.value),
              fontWeight: 500,
            }}
          />
        ),
    },

    { field: 'createdDate', 
      headerName: 'Created Date', 
      width: 130,
      filterColumnName:"createdAt",
      filterType:filterTypeOptions.dateRange,
    },
    { field: 'lastUpdate', 
      headerName: 'Last Update', 
      width: 130,
      filterColumnName:"updatedAt",
      filterType:filterTypeOptions.dateRange, 
    },

    {
      field: 'completion',
      headerName: 'Completion',
      flex: 1,
      minWidth: 100,
      filterColumnName:"completionPercentage",
      filterType:filterTypeOptions.numberRange, 
      renderCell: (params) => (
        <Box
          sx={{
            color: params.value >= 80 ? '#22c55e' : params.value >= 50 ? '#f59e0b' : '#098B34',
            fontWeight: 500,
            fontSize: '13px',
          }}
        >
          {params.value}%
        </Box>
      ),
    },
    {
      field: 'createdBy',
      headerName: 'Created By',
      flex: 1,
      minWidth: 130,
      filterColumnName:"createdBy",
      filterType:filterTypeOptions.string, 
      renderCell: (params) =>
        loading ? <Skeleton width={80} /> : params.value,
    },
    {
      field: 'reviewedBy',
      headerName: 'Reviewed By',
      flex: 1,
      minWidth: 130,
      filterColumnName:"reviewedBy",
      filterType:filterTypeOptions.string, 
    },
    {
      field: 'comments',
      headerName: 'Comments',
      flex: 1,
      minWidth: 160,
      filterColumnName:"comments",
      filterType:filterTypeOptions.string, 
      renderCell: (params) => {
        const rawStatus = params.row.status || ''
        const normalizedStatus = rawStatus.trim().toLowerCase()
        const isViewableStatus = ['rework'].includes(normalizedStatus)

        return (
          <Button
            size="small"
            variant="outlined"
            disabled={!isViewableStatus}
            sx={{ fontSize: '12px', textTransform: 'none' }}
            onClick={() =>
              isViewableStatus && handleOpenCommentModal(params.row.id, 'course')
            }
          >
            View
          </Button>
        )
      },
    },
    {
      field: 'action',
      headerName: 'Action',
      filterable:false,
      width: 100, // fixed size for button
      renderCell: (params) => {
        const isEditable = ['Draft', 'Rework'].includes(params.row.status)
        return (
          <Button
            variant="contained"
            size="small"
            disabled={!isEditable}

            sx={{
              fontSize: '12px',
              textTransform: 'none',
              backgroundColor: isEditable ? '#0463EF' : '#ccc',
            }}
            onClick={() => navigate(`/user/course-review/course-details/${params?.row?.courseId}`)}
          >
            Edit
          </Button>
        )
      },
    },
  ]



  function getStatusBgColor(status) {
    switch (status) {
      case 'Live':
        return '#fff'
      case 'Draft':
        return '#fff'
      case 'Rework':
        return '#fff'
      case 'Re-Sumbited':
        return '#fff'
      default:
        return '#fff'
    }
  }

  function getStatusTextColor(status) {
    switch (status) {
      case 'Live':
        return '#363853' // darker green
      case 'Draft':
        return '#363853' // darker gray
      case 'Rework':
        return '#363853' // darker orange
      case 'Re-Sumbited':
        return '#363853' // darker red
      default:
        return '#666'
    }
  }

  // Helper functions for status colors
  function getStatusColor(status) {
    switch (status) {
      case 'Approved':
        return '#22c55e' // green
      case 'Draft':
        return '#64748b' // grayish
      case 'Pending':
        return '#f97316' // orange
      case 'Rework':
        return '#f97316' // orange
      case 'Re-Sumbited':
        return '#ef4444' // red
      default:
        return '#999'
    }
  }


  return (
    <>
      {/* Apply global styles to DataGrid dropdown menus */}
      {/* <GlobalStyles
        styles={{
          '.MuiDataGrid-menuList': {
            fontSize: '13px',
            padding: '4px 0',
          },
          '.MuiDataGrid-panelContent': {
            fontSize: '13px',
            padding: '4px 0',
          },
          '.MuiSelect-select': {
            fontSize: '13px',
            padding: '4px 0',
          },
          '.MuiList-root .MuiButtonBase-root': {
            fontSize: '13px',
          },
          '.MuiDataGrid-panelContent .MuiOutlinedInput-input': {
            fontSize: '13px',
          },
          '.MuiDataGrid-columnsManagement .MuiFormControlLabel-root .MuiFormControlLabel-label': {
            fontSize: '13px',
          },
          '.MuiDataGrid-menuList .MuiTypography-root': {
            fontSize: '13px',
          },
          '.MuiDataGrid-menuList .MuiMenuItem-root': {
            fontSize: '13px',
            padding: '6px 12px',
          },
          '.MuiDataGrid-menuList .MuiMenuItem-root:hover': {
            backgroundColor: '#f5f5f5',
          },
          '& .MuiDataGrid-columnHeaders': {
            position: 'sticky',
            top: 0,
            zIndex: 2,
            backgroundColor: '#fff',
          },
          '& .MuiDataGrid-cell.sticky-col-1': {
            position: 'sticky',
            left: 0,
            background: '#fff',
            zIndex: 2,
          },
          '& .MuiDataGrid-columnHeader.sticky-col-1': {
            position: 'sticky',
            left: 0,
            background: '#fff',
            zIndex: 3, // slightly higher than cell
          },
        }}
      /> */}

      <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
        <div className="page-header" style={{ position: 'sticky', top: '4.5rem', zIndex: '9', padding: '10px 15px', borderBottom: '1px solid #E6E7E8', background: '#fff', }}>
          <div className="row align-items-center">
            <div className="col">
              <Typography sx={{ fontSize: '18px', fontWeight: '600', color: '#15243E', display: 'flex', alignItems: 'center', gap: 1, }}><Link href="/" className='d-flex'><BackArrowIcon /></Link>Courses Listing Management </Typography>
            </div>
            {/* End Col */}
            <div className="col">  <Box display="flex" gap={2} sx={{ justifyContent: 'end', }}>

              <Button onClick={() => navigate('/user/course-review/course-details')} sx={{ background: '#0463EF', color: '#fff', minHeight: 'auto', padding: '4px 15px', fontSize: '14px', textTransform: 'capitalize', }}>
                Add Course
              </Button>
            </Box></div>
          </div>
          {/* End Col */}
        </div>
        <UniversitySummary type="course" requestParams={{createdBy:authSlice?.user?._id}}/>
        {/* Filter Toolbar */}
        <CommonFilterTab type='course' module='student' searchPlaceholder='Search course name...' detailType='Course Details' fetchList={setSearchFilter} showCount={rows?.length} rowCount={rowCount} isStatus={true}/>

        {/* Data Table */}
        <CommonDataTable columns={columns} rows={rows} idKey="field" loading={loading} filterEnabled={true} rowCount={rowCount} 
        pageFilters={pageFilters}
        handleFliterSliceChange={handleFliterSliceChange}
         />
        
      </Box>

      <UserCommentModal
        open={openCommentModal}
        onClose={() => setOpenCommentModal(false)}
        onSave={handleSaveComment}
        commentText={commentText}
        setCommentText={setCommentText}
        mode='view'
      />
    </>
  )
}

export default CourseReviewUser
